import React from 'react';
import Chip from '@material-ui/core/Chip';
import Avatar from '@material-ui/core/Avatar';
import CheckIcon from '@material-ui/icons/Check'
import WarningIcon from '@material-ui/icons/Warning';
import ErrorIcon from '@material-ui/icons/Error'
import makeStyles from '@material-ui/core/styles/makeStyles';
import PropTypes from 'prop-types';

const getColors = (theme, variant) => {
	switch (variant) {
		case 'error':
			return {
				icon: '#fee0b8',
				iconBg: theme.palette.error.dark,
				textBg: theme.palette.error.main,
				text: theme.palette.getContrastText(theme.palette.error.main),
			};
		case 'warn':
			return {
				icon: '#f3f6c8',
				iconBg: '#ffc82b',
				textBg: '#fede32',
				text: theme.palette.getContrastText('#fede32'),
			};
		default:
		case 'ok':
			return {
				icon: theme.palette.secondary.light,
				iconBg: theme.palette.secondary.dark,
				textBg: theme.palette.secondary.main,
				text: theme.palette.getContrastText(theme.palette.secondary.main),
			};
	}
};

const useStyles = makeStyles(theme => ({
	root: {
		display: 'flex',
		justifyContent: 'center',
		flexWrap: 'wrap',
	},
	chip: ({variant}) => {
		const colors = getColors(theme, variant);
		return ({
			margin: theme.spacing(1),
			background: colors.textBg,
			'&:hover': {
				background: colors.iconBg,
			},
			color: colors.text,
		});
	},
	avatar: ({variant}) => {
		const colors = getColors(theme, variant);
		return ({
			color: colors.icon,
			width: '31px',
			height: '31px',
			background: colors.iconBg,
			margin: '0px',
		});
	},
}));


export const MessageChip = (props) => {
	const {label, variant = 'ok', onClick} = props;
	const classes = useStyles(props);
	let IconComponent;
	switch (variant) {
		case 'error':
			IconComponent = ErrorIcon;
			break;
		case 'warn':
			IconComponent = WarningIcon;
			break;
		case 'ok':
			IconComponent = CheckIcon;
			break;
	}
	return (
		<Chip
			icon={<Avatar className={classes.avatar}><IconComponent fontSize={'small'}/></Avatar>}
			label={label}
			className={classes.chip}
			onClick={onClick}
		/>
	);
};

MessageChip.propTypes = {
	variant: PropTypes.oneOf(['error', 'warn', 'ok']),
};